import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useExpenseOptions() {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, isFetching } = useQuery<string[], Error>(
    ['expense'],
    () => quoteService.getExpenseOptions(),
    {
      onError: error => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
      retry: false,
    }
  );
  return { expenseOptions: data, isLoading, isFetching } as const;
}
